import {API_URL} from 'api/constants'

export const MODIFIERS = `${API_URL}/v2/modifiers`
export const V1_MODIFIER = `${API_URL}/v1/modifiers`
export const MODIFIER_BY_ID = (id) => `${API_URL}/v1/modifiers/${id}`
export const V1_DELETE_MODIFIER = (id) => `${API_URL}/v1/modifiers/${id}/delete_modifier`
export const CREATE_ALL_OUTLET = `${API_URL}/v1/modifiers/create_all_outlet`
export const V1_APPLY_TO_ITEMS = (id) => `${API_URL}/v1/modifiers/${id}/apply_to_items`
export const V1_SHOW_ITEM_MODIFIER = (id) => `${API_URL}/v1/modifiers/show_item_modifier`



// WEBPACK FOOTER //
// ./app/api/modifiers/constants.js